<template>
  <div class="qr-login-wrapper">
    <div class="code-login-wrapper">
      <div class="left-box">
        <img
          src="https://cdn.max-c.com/heybox/dailynews/img/80423d9d663a8b47c1a0736fb5fa2ff9.png"
          alt=""
        />
      </div>
      <div class="right-box">
        <div class="qr-code-wrapper">
          <div class="fail-box" v-if="login_qrcode_state == 'cancel'">
            <p class="title">二维码已失效</p>
            <p class="refresh" @click="getLoginQrCode">点击刷新</p>
          </div>
          <div class="success-box" v-if="login_qrcode_state == 'ready'">
            <p class="icon"><i class="iconfont heybox-action-select"></i></p>
            <p class="title">扫描成功</p>
            <p class="desc">请在手机上确认登录</p>
          </div>
          <div class="success-box" v-if="login_qrcode_state == 'ok'">
            <p class="icon"><i class="iconfont heybox-action-select"></i></p>
            <p class="title">扫描成功</p>
            <p class="desc">登录成功，即将跳转</p>
          </div>
          <div class="qrcode-box" v-if="login_qrcode_state == 'wait'">
            <canvas ref="login-qrcode" id="login-qrcode"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-bar app-login">
      <div class="btn change-login" @click="changeLogin">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.19526 3.52864C6.45561 3.26829 6.87772 3.26829 7.13807 3.52864L11.1381 7.52864C11.3984 7.78899 11.3984 8.2111 11.1381 8.47145L7.13807 12.4714C6.87772 12.7318 6.45561 12.7318 6.19526 12.4714C5.93491 12.2111 5.93491 11.789 6.19526 11.5286L9.72386 8.00004L6.19526 4.47145C5.93491 4.2111 5.93491 3.78899 6.19526 3.52864Z"
            fill="#8c9196"
          />
        </svg>
        <span>验证码登录</span>
      </div>
      <div class="btn" @click="wechatLogin">
        <IconBase width="20" height="20">
          <IconWechat />
        </IconBase>
        <span>微信登录</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getLoginQrCodeState, getLoginQrCode } from '_api/account/login-v2';
import IconBase from './IconBase';
import IconWechat from './IconWechat';
import QRCode from 'qrcode';

export default {
  components: {
    IconBase,
    IconWechat,
  },
  data() {
    return {
      login_qrcode_state: '',
    };
  },
  methods: {
    //扫码登录
    getLoginQrCode() {
      if (this.login_qrcode_state == 'loading') {
        return;
      }
      this.login_qrcode_state = 'loading';
      getLoginQrCode({
        app: 'web',
        _notip: true,
      }).then((res) => {
        if (res.data.status === 'ok') {
          var data = res.data.result;
          this.login_qrcode_state = 'wait';
          this.login_qrcode_url = data.qr_url;
          var url = new URL(data.qr_url);
          this.qr = url.searchParams.get('qr');
          setTimeout(() => {
            this.setLoginQrcode();
          }, 0);
          clearTimeout(this.login_qrcode_timer);
          this.login_qrcode_timer = setTimeout(() => {
            this.getLoginQrCodeState();
          }, 1500);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getLoginQrCodeState() {
      getLoginQrCodeState({
        qr: this.qr,
        web_source: 'open',
        app: 'web',
      }).then((res) => {
        if (res.data.status === 'ok') {
          var data = res.data.result;
          this.login_qrcode_state = data.error;
          if (data.error == 'wait' || data.error == 'ready') {
            this.login_qrcode_timer = setTimeout(() => {
              this.getLoginQrCodeState();
            }, 1500);
          } else if (data.error == 'ok') {
            this.$emit('setUserInfo', res);
          }
        } else if (res.data.status == 'need_google_check') {
          this.$emit('googleVertify', res.data.result);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    setLoginQrcode() {
      QRCode.toCanvas(
        this.$refs['login-qrcode'],
        this.login_qrcode_url,
        {
          width: 184,
          height: 184,
        },
        (err) => {
          if (err) {
            this.$message.error(err);
          }
        },
      );
    },
    changeLogin() {
      clearTimeout(this.login_qrcode_timer);
      this.$emit('changeLogin', 'code');
    },
    wechatLogin() {
      this.$emit('wechatLogin');
    },
  },
};
</script>
<style lang="less">
.qr-login-wrapper {
  .code-login-wrapper {
    width: 100%;
    height: 192px;
    display: flex;
    align-items: flex-end;
    margin-top: 20px;
    .right-box {
      width: 184px;
      height: 184px;
      margin-left: 26px;
      .qr-code-wrapper {
        width: 100%;
        height: 100%;
      }
      .fail-box,
      .success-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .qrcode-box {
          width: 100%;
          height: 100%;
          #login-qrcode {
            width: 100%;
            height: 100%;
          }
        }
        .icon {
          width: 40px;
          height: 40px;
          margin-bottom: 16px;
          color: #fff;
          border-radius: 50%;
          .iconfont {
            width: 40px;
            height: 40px;
            font-size: 24px;
            &:before {
              line-height: 40px;
            }
          }
        }
        .title {
          line-height: 16px;
          font-size: 16px;
          color: #14191e;
          font-weight: 600;
        }
        .refresh,
        .desc {
          line-height: 12px;
          margin-top: 12px;
          font-size: 12px;
        }
        .refresh {
          cursor: pointer;
          color: #168fd0;
        }
        .desc {
          color: #14191e;
        }
      }
    }
    .left-box {
      width: 180px;
      height: 192px;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .bottom-bar {
    display: flex;
    margin-top: 20px;
    user-select: none;
    justify-content: space-between;
    &.app-login {
      padding: 0 18px 0 12px;
    }
    .btn {
      display: flex;
      align-items: center;
      color: #8c9196;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      &:hover {
        color: #14191e;
      }
      svg {
        margin-right: 6px;
        > g {
          transition: 0.2s linear;
        }
      }
      &.change-login {
        svg {
          margin-right: 0;
          transform: rotate(180deg);
        }
      }
      span {
        transition: 0.2s linear;
      }
    }
  }
}
</style>
